import { CustomBookingMethod } from '~api/config';

import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DropdownMenu } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  customBookingMethod: CustomBookingMethod;
  trigger: ReactNode;
}

export function Menu(props: Props) {
  const { customBookingMethod, trigger } = props;
  const { t } = useTranslation();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>{trigger}</DropdownMenu.Trigger>

      <DropdownMenu.Content>
        <DropdownMenu.Item asChild>
          <RouterLink to={`${customBookingMethod.method}`}>{t('common.showDetails')}</RouterLink>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
